import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from '../../../../assets/close.svg';
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useCreateTemplate } from "hooks/mutations/useCreateTemplate";
import { Input } from "components/Form/Input";
import { Textarea } from "components/Form/Textarea";
import { InputGroup } from "styles/InputGroup";
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { Buttons } from "components/MessageForm/styles";
import { useCategories } from "hooks/fetch/useCategories";

export function CreateTemplateModal({ isOpen, onRequestClose }: any) {
    const { data: categories, isLoading: isLoadingCategories } = useCategories();

    const { handleSubmit, setValue, getValues, control, reset, register, formState: { isSubmitting } } = useForm<FieldValues>({
        defaultValues: {
            title: '',
            message: '',
            name_meta: '',
            manual_send: true,
            department_id: null,
            category: 'UTILITY',
        },
    });

    function handleRequestClose() {
        reset();
        onRequestClose();
    }

    function insertPlaceholder(textareaId: string, placeholder: string) {
        const textarea = document.getElementById(textareaId) as HTMLTextAreaElement;
        const start = textarea?.selectionStart ?? (getValues('message') ?? '').length;
        const end = textarea?.selectionEnd ?? start;
        const current = getValues('message') ?? '';
        setValue('message', current.substring(0, start) + placeholder + current.substring(end));
        setTimeout(() => {
            if (!textarea) return;
            textarea.selectionStart = start + placeholder.length;
            textarea.selectionEnd = start + placeholder.length;
            textarea.focus();
        }, 0);
    }

    const createTemplate = useCreateTemplate();

    async function handleCreateTemplate(formData: any) {
        const data = { ...formData, department_id: formData.department_id || null };
        await createTemplate.mutateAsync({ data });
        handleRequestClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleRequestClose}
            overlayClassName="react-modal-overlay"
            className="react-modal-content fixed-height"
        >
            <button type="button" onClick={handleRequestClose} className="react-modal-close">
                <img src={closeImg} alt="Fechar modal" loading="lazy" />
            </button>

            <div>
                <ModalTitle>Criar template</ModalTitle>
                <Form onSubmit={handleSubmit(handleCreateTemplate as SubmitHandler<FieldValues>)}>
                    <InputGroup>
                        <Input control={control} type="text" name="title" id="title" label="Título" maxLength={255} fullwidth />
                    </InputGroup>
                    <InputGroup>
                        <Input control={control} type="text" name="name_meta" id="name_meta" label="Nome Meta (identificador na Meta)" maxLength={255} fullwidth />
                    </InputGroup>
                    <InputGroup>
                        <Textarea control={control} name="message" id="message_create" label="Mensagem" rows={6} fullwidth />
                        <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                            <Button type="button" small onClick={() => insertPlaceholder('message_create', '{{contact_name}}')}>Nome do cliente</Button>
                            <Button type="button" small onClick={() => insertPlaceholder('message_create', '{{consultant_name}}')}>Nome do consultor</Button>
                        </div>
                    </InputGroup>
                    <InputGroup>
                        <label style={{ fontSize: 12, marginBottom: 4, display: 'block' }}>Categoria Meta</label>
                        <select {...register('category')} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}>
                            <option value="UTILITY">Utilidade</option>
                            <option value="MARKETING">Marketing</option>
                        </select>
                    </InputGroup>
                    <InputGroup>
                        <label style={{ fontSize: 12, marginBottom: 4, display: 'block' }}>Número na meta</label>
                        <select {...register('waba_id')} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}>
                            <option value="473792399151593">+55 48 99604-9333</option>
                            <option value="497528036768966">+55 48 99658-2208</option>
                        </select>
                    </InputGroup>
                    <InputGroup>
                        <label style={{ fontSize: 12, marginBottom: 4, display: 'block' }}>Departamento</label>
                        <select {...register('department_id')} disabled={isLoadingCategories} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}>
                            <option value="">Todos os departamentos</option>
                            {categories?.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </InputGroup>
                    <InputGroup>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14 }}>
                            <input type="checkbox" {...register('manual_send')} defaultChecked />
                            Permitir envio manual
                        </label>
                    </InputGroup>
                    <InputGroup>
                        <Buttons>
                            <Button type="submit" fullwidth disabled={isSubmitting}>{isSubmitting ? 'Criando...' : 'Criar'}</Button>
                            <Button type="button" onClick={handleRequestClose}>Cancelar</Button>
                        </Buttons>
                    </InputGroup>
                    <p>*Ficará disponível depois de 20 minutos</p>
                </Form>
            </div>
        </Modal>
    );
}
